import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { Button, Events, EventsEmitter } from 'msp-components'
import translations from './OrderSubscriptionAction.constants'
import * as S from './OrderSubscriptionAction.styles'
import OrderSubscriptionModal from './OrderSubscriptionModal'
import { OrderSubscriptionActionProps } from '../OrderActions.types'

const OrderSubscriptionAction = ({
  products = [],
  shippingAddress,
  billingAddress,
  paymentID,
  isProcessing,
  setIsProcessing
}: OrderSubscriptionActionProps) => {
  const { formatMessage } = useIntl()
  const subscriptionModalEmitter = useRef(EventsEmitter)

  return (
    <>
      <Button
        className={S.ActionButton}
        variant='outline'
        type='secondary'
        isDisabled={isProcessing}
        onClick={() => {
          subscriptionModalEmitter.current?.dispatch(
            Events.OPEN_SUBSCRIPTION_MODAL,
            { products, shippingAddress, billingAddress, paymentID }
          )
        }}
      >
        {formatMessage(translations.subscribe)}
      </Button>
      <OrderSubscriptionModal
        isProcessing={isProcessing}
        setIsProcessing={setIsProcessing}
      />
    </>
  )
}

export default OrderSubscriptionAction
